/* DOI website analytics. No account IDs, form values, raw searches or private records. */
(() => {
  'use strict';
  if (window.DOIAnalytics) return;
  const node = document.getElementById('doi-analytics-config');
  if (!node) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch { return; }
  const query = new URLSearchParams(location.search);
  const qa = query.get('doi_qa') === '1';
  const preview = config.preview || query.has('preview_theme_id') || query.has('section_id');
  const privatePage = /^\/(?:account|checkout|checkouts)(?:\/|$)/.test(location.pathname) || /^\/pages\/(?:my-doi|my-home-search)(?:\/|$)/.test(location.pathname);
  const account = { ready: !config.signedIn, owner: false, allowed: true };
  const pending = [];
  const diagnostics = [];
  const allowedEvents = new Set(['doi_save_resource','doi_engaged_read','doi_read_milestone','doi_scroll_depth','doi_search_performed','doi_search_no_results','doi_search_result_selected','doi_search_filtered','doi_tool_open','doi_tool_interaction','doi_bloom_click','doi_contact_click','doi_contact_submit','doi_inquiry_submit','doi_next_step_view','doi_next_step_click','doi_next_step_arrival','doi_next_step_continue']);
  const tools = { '/pages/coachella-valley-atlas':'atlas', '/pages/coachella-valley-development-map':'development_map', '/pages/coachella-valley-interactive-map':'regional_map', '/pages/coachella-valley-restaurant-guide':'restaurant_guide', '/pages/coachella-valley-trip-planner':'trip_planner' };
  const safePath = value => {
    try {
      const url = new URL(value || location.href, location.origin);
      if (url.origin !== location.origin || !/^\/(?:$|search\/?$|(?:blogs|pages|products|collections)\/[a-z0-9/_-]+\/?$)/i.test(url.pathname)) return '';
      if (/^\/pages\/(?:my-doi|my-home-search)(?:\/|$)/.test(url.pathname)) return '';
      return url.pathname.replace(/\/$/, '') || '/';
    } catch { return ''; }
  };
  const path = safePath(location.href);
  const base = { doi_content_type: config.contentType || 'other', doi_content_group: config.contentGroup || 'other', doi_tool: tools[path] || 'none' };
  let nextStepAttribution = null;
  const clean = input => {
    const out = { ...base };
    for (const key of ['doi_action','doi_search_surface','doi_result_type','doi_inquiry_type','doi_choice']) {
      const value = String(input[key] || '');
      if (/^[a-z][a-z0-9_]{0,39}$/.test(value)) out[key] = value;
    }
    for (const key of ['doi_read_seconds','doi_scroll_percent','doi_result_count']) {
      const value = Number(input[key]);
      if (input[key] !== undefined && Number.isFinite(value) && value >= 0) out[key] = Math.min(100000, Math.round(value));
    }
    const result = (input.result_path || input.doi_result_path) && safePath(input.result_path || input.doi_result_path);
    if (result) out.doi_result_path = result;
    const source = input.doi_source_path && safePath(input.doi_source_path);
    if (source) out.doi_source_path = source;
    return out;
  };
  const consent = () => navigator.globalPrivacyControl !== true && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const ignored = () => { try { return localStorage.getItem('plausible_ignore') === 'true' || localStorage.getItem('doi_analytics_ignore') === '1'; } catch { return false; } };
  function note(name, props, status) {
    if (!qa) return;
    diagnostics.push({ name, props, status });
    if (diagnostics.length > 40) diagnostics.shift();
    let output = document.getElementById('doi-analytics-diagnostics');
    if (!output) { output = document.createElement('script'); output.type = 'application/json'; output.id = 'doi-analytics-diagnostics'; document.body.append(output); }
    output.textContent = JSON.stringify({ version: 1, qa: true, events: diagnostics });
  }
  function send(name, props = {}) {
    if (!allowedEvents.has(name) || privatePage || !path) return false;
    const attributed = nextStepAttribution && Date.now() - nextStepAttribution.at <= 30 * 60 * 1000
      && ['doi_save_resource','doi_engaged_read','doi_read_milestone'].includes(name)
      && (name !== 'doi_save_resource' || safePath(props.result_path || props.doi_result_path) === path);
    const data = clean(attributed ? { ...props, doi_source_path: nextStepAttribution.source, doi_choice: nextStepAttribution.choice } : props);
    if (qa) { note(name, data, 'dry_run'); return false; }
    if (preview || ignored() || !consent() || account.owner || !account.allowed) return false;
    if (!account.ready) { if (pending.length < 12) pending.push([name, data]); return false; }
    const url = location.origin + path;
    const ref = safePath(document.referrer);
    if (typeof window.gtag === 'function') window.gtag('event', name, { ...data, send_to: config.measurementId, page_location: url, page_referrer: ref ? location.origin + ref : '', page_title: 'Desert Oasis Insider — ' + base.doi_content_group });
    if (typeof window.clarity === 'function' && data.doi_source_path && data.doi_choice) {
      window.clarity('set', 'doi_next_step_source', data.doi_source_path);
      window.clarity('set', name + '_choice', data.doi_choice);
      window.clarity('event', name);
    }
    // The Events API lets us omit query strings, unlike the installed legacy script.
    fetch('https://plausible.io/api/event', { method: 'POST', headers: { 'Content-Type': 'text/plain' }, credentials: 'omit', keepalive: true, body: JSON.stringify({ name, url, domain: config.plausibleDomain, referrer: ref ? location.origin + ref : null, props: data, interactive: !['doi_tool_open','doi_scroll_depth','doi_next_step_view'].includes(name) }) }).catch(() => {});
    return true;
  }
  window.doiTrack = send;
  window.DOIAnalytics = Object.freeze({ version: 3 });
  window.doiAnalyticsAccount = state => {
    account.ready = true;
    account.owner = state?.owner === true;
    account.allowed = state?.allowed !== false;
    const waiting = pending.splice(0);
    if (!account.owner && account.allowed) waiting.forEach(([name, props]) => send(name, props));
    recordContactCompletion();
    resumeNextSteps();
  };
  document.addEventListener('visitorConsentCollected', () => { if (!consent()) { pending.length = 0; activeMs = 0; try { sessionStorage.removeItem('doi_next_step_v1'); } catch {} } else { openTool(); recordContactCompletion(); } resumeNextSteps(); });
  document.addEventListener('doi:search-event', event => {
    if (document.querySelector('[data-search-scope="private"]')) return;
    const data = event.detail || {};
    if (!allowedEvents.has(data.name)) return;
    send(data.name, { doi_result_count: data.count, doi_search_surface: data.surface, doi_result_type: data.type, result_path: data.result_url });
  });
  document.addEventListener('click', event => {
    if (!event.isTrusted) return;
    const link = event.target.closest?.('a[href]');
    if (link) {
      let url; try { url = new URL(link.href, location.origin); } catch { return; }
      if (['searchhomeswithbloom.com','www.searchhomeswithbloom.com'].includes(url.hostname)) send('doi_bloom_click', { doi_action: 'bloom' });
      else if (['tel:','mailto:','sms:'].includes(url.protocol)) send('doi_contact_click', { doi_action: url.protocol === 'tel:' ? 'phone' : url.protocol === 'sms:' ? 'text' : 'email' });
    }
    if (!tools[path]) return;
    const control = event.target.closest?.('button,[role="button"],input[type="checkbox"],input[type="radio"]');
    if (control && document.getElementById('MainContent')?.contains(control) && !control.closest('[data-mydoi-config],#my-doi,dialog')) send('doi_tool_interaction', { doi_action: 'control_click' });
  }, true);
  document.addEventListener('change', event => {
    if (event.isTrusted && tools[path] && event.target.matches?.('select') && document.getElementById('MainContent')?.contains(event.target)) send('doi_tool_interaction', { doi_action: 'filter_change' });
  });
  let activeMs = 0;
  let last = performance.now();
  let scroll = 0;
  const readSent = new Set();
  const depthSent = new Set();
  const article = config.contentType === 'article' ? document.querySelector('#MainContent article') || document.getElementById('MainContent') : null;
  function depth() {
    if (!article) return 0;
    const box = article.getBoundingClientRect();
    return Math.max(0, Math.min(100, Math.round((innerHeight - box.top) / Math.max(1, box.height) * 100)));
  }
  function tick() {
    const now = performance.now();
    const delta = Math.min(2000, now - last); last = now;
    if (!article || document.hidden || !document.hasFocus() || (!qa && (!consent() || ignored() || account.owner || !account.allowed || !account.ready || preview))) return;
    activeMs += delta;
    scroll = Math.max(scroll, depth());
    for (const percent of [50,90]) if (scroll >= percent && !depthSent.has(percent)) { depthSent.add(percent); send('doi_scroll_depth', { doi_scroll_percent: percent }); }
    for (const seconds of [30,60]) if (activeMs >= seconds * 1000 && scroll >= 50 && !readSent.has(seconds)) { readSent.add(seconds); send(seconds === 30 ? 'doi_engaged_read' : 'doi_read_milestone', { doi_read_seconds: seconds, doi_scroll_percent: scroll }); }
  }
  document.addEventListener('visibilitychange', () => { last = performance.now(); });
  window.addEventListener('focus', () => { last = performance.now(); });
  if (article) setInterval(tick, 1000);
  let toolOpened = false;
  const openTool = () => { if (tools[path] && !toolOpened && (qa || consent())) { toolOpened = true; send('doi_tool_open'); } };
  if (window.Shopify?.customerPrivacy) openTool();
  else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) { openTool(); resumeNextSteps(); } });

  const contactKey = 'doi_contact_pending_v1';
  const contactSuccess = document.querySelector('[data-doi-contact-success]');
  function recordContactCompletion() {
    if (!contactSuccess || (!qa && (preview || ignored() || !consent() || !account.ready || account.owner || !account.allowed))) return;
    let submission;
    try {
      submission = JSON.parse(sessionStorage.getItem(contactKey) || 'null');
      if (!submission || submission.path !== path || !Number.isFinite(submission.at) || Date.now() - submission.at < 0 || Date.now() - submission.at > 30 * 60 * 1000) {
        sessionStorage.removeItem(contactKey);
        return;
      }
      sessionStorage.removeItem(contactKey);
    } catch { return; }
    send('doi_contact_submit', { doi_action: 'confirmed' });
    if (['buying','selling'].includes(submission.type)) send('doi_inquiry_submit', { doi_action: 'confirmed', doi_inquiry_type: submission.type });
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!event.isTrusted || !form.matches?.('.doi-contact__form') || !form.checkValidity() || privatePage || !path) return;
    if (!qa && (preview || ignored() || !consent() || !account.ready || account.owner || !account.allowed)) return;
    const topic = form.querySelector('[data-doi-topic]')?.selectedOptions[0]?.dataset.topicKey;
    try { sessionStorage.setItem(contactKey, JSON.stringify({ path, at: Date.now(), type: ['buying','selling'].includes(topic) ? topic : 'other' })); } catch {}
  }, true);
  recordContactCompletion();

  // Four discovery pilots. Fixed public paths and choice names keep labels and private data out of analytics.
  const nextSteps = {
    '/blogs/things-to-do/cotino-bay-beach-dining-shops-what-to-expect': {
      section: 'cotino-next-steps', choices: [
        { choice: 'cotino_project', href: '/pages/cotino-rancho-mirage-ca' },
        { choice: 'cotino_nearby', href: '#nearby-rancho-mirage' },
        { choice: 'cotino_updates', selector: 'button[data-bay-action="follow_guide"]' }
      ]
    },
    '/products/salton-sea-state-recreation-area': {
      section: 'salton-next-steps', choices: [
        { choice: 'salton_birding', href: '/blogs/nature/salton-sea-ca-bird-watching-guide' },
        { choice: 'salton_nearby', href: '#salton-nearby-stops' },
        { choice: 'salton_history', href: '/blogs/history/salton-sea-a-journey-through-time' }
      ]
    },
    '/blogs/history/the-complete-history-of-coachella-from-pearl-jam-in-1993-to-the-25th-festival': {
      section: 'festival-next-steps', choices: [
        { choice: 'coachella_venue', href: '/products/empire-polo-club' },
        { choice: 'coachella_indio', href: '/blogs/history/why-indio-exists-from-railroad-water-stop-to-city-of-festivals' },
        { choice: 'coachella_day_trip', href: '/blogs/things-to-do/beyond-festivals-indio-coachella-day-trip' }
      ]
    },
    '/blogs/nature/salton-sea-ca-bird-watching-guide': {
      section: 'bird-next-steps', choices: [
        { choice: 'birding_species', href: '/collections/birds' },
        { choice: 'birding_history', href: '/blogs/history/salton-sea-a-journey-through-time' },
        { choice: 'birding_routes', href: '/blogs/things-to-know/salton-sea-day-trip-routes' }
      ]
    }
  };
  const nextStepKey = 'doi_next_step_v1';
  const nextStepTTL = 30 * 60 * 1000;
  const nextStepViews = new Set();
  const nextStepVisible = new Set();
  const nextStepElements = new Map();
  const nextStepAllowed = () => !privatePage && !!path && !preview && !ignored() && consent() && account.ready && !account.owner && account.allowed;
  const nextStepTarget = item => item.href?.startsWith('#') ? path : item.href ? safePath(item.href) : '';
  const nextStepProps = (state, target = state.target) => ({ doi_source_path: state.source, doi_choice: state.choice, result_path: target });
  function readNextStep() {
    try {
      const state = JSON.parse(sessionStorage.getItem(nextStepKey) || 'null');
      const choice = nextSteps[state?.source]?.choices.find(item => item.choice === state.choice);
      if (!choice || !choice.href || choice.href.startsWith('#') || state.target !== safePath(choice.href)
        || !Number.isFinite(state.at) || Date.now() - state.at < 0 || Date.now() - state.at > nextStepTTL
        || !['selected','arrived','next_selected','continued'].includes(state.stage)
        || (state.stage === 'next_selected' && (!state.next || safePath(state.next) !== state.next))) {
        sessionStorage.removeItem(nextStepKey); return null;
      }
      return state;
    } catch { return null; }
  }
  function writeNextStep(state) {
    // Preview and QA never persist attribution or send production events.
    if (!nextStepAllowed()) return;
    try { sessionStorage.setItem(nextStepKey, JSON.stringify(state)); } catch {}
  }
  function resumeNextSteps() {
    if (!qa && !nextStepAllowed()) {
      nextStepAttribution = null;
      if (!preview && !qa && (account.owner || !account.allowed || ignored())) try { sessionStorage.removeItem(nextStepKey); } catch {}
      return;
    }
    if (!qa) {
      const state = readNextStep();
      const referrer = safePath(document.referrer);
      if (state?.stage === 'selected' && path === state.target && referrer === state.source) {
        send('doi_next_step_arrival', nextStepProps(state));
        state.stage = 'arrived'; writeNextStep(state);
      } else if (state?.stage === 'next_selected' && path === state.next && referrer === state.target) {
        send('doi_next_step_continue', nextStepProps(state, path));
        state.stage = 'continued'; writeNextStep(state);
      }
      if (state && state.target === path && ['arrived','next_selected'].includes(state.stage)) nextStepAttribution = state;
    }
    for (const element of nextStepVisible) {
      const item = nextStepElements.get(element);
      if (!item || nextStepViews.has(item.choice) || document.hidden || !document.hasFocus()) continue;
      if (send('doi_next_step_view', nextStepProps({ source: path, ...item }, nextStepTarget(item))) || qa) nextStepViews.add(item.choice);
    }
  }
  const pilot = nextSteps[path];
  if (pilot) {
    const section = document.getElementById(pilot.section);
    for (const item of pilot.choices) {
      const element = section?.querySelector(item.selector || `a[href="${item.href}"]`);
      if (element) nextStepElements.set(element, item);
    }
    if (typeof IntersectionObserver === 'function') {
      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) nextStepVisible.add(entry.target);
          else nextStepVisible.delete(entry.target);
        }
        resumeNextSteps();
      }, { threshold: [0, 0.5] });
      nextStepElements.forEach((item, element) => observer.observe(element));
    }
  }
  document.addEventListener('visibilitychange', resumeNextSteps);
  window.addEventListener('focus', resumeNextSteps);
  document.addEventListener('click', event => {
    if (!event.isTrusted || event.button > 0) return;
    const control = event.target.closest?.('a[href],button');
    const item = nextStepElements.get(control);
    if (item) {
      const target = nextStepTarget(item);
      send('doi_next_step_click', nextStepProps({ source: path, ...item }, target));
      if (target && target !== path && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && control.target !== '_blank' && !control.hasAttribute('download')) {
        writeNextStep({ source: path, choice: item.choice, target, at: Date.now(), stage: 'selected' });
      }
    } else if (nextStepAttribution && control?.matches('a[href]') && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && control.target !== '_blank' && !control.hasAttribute('download')) {
      const next = safePath(control.href);
      if (next && next !== path) writeNextStep({ ...nextStepAttribution, stage: 'next_selected', next });
    }
  }, true);
  resumeNextSteps();

  if (qa) note('ready', base, 'dry_run_no_network');
})();
